import _ from "lodash";
export default {
  props: {
    ordine: Object,
  },
  data() {
    return {
      menu_add: false,
      selectedItem: null,
      prodotto_sel_id: null,
      nome_prodotto: "",
      lista_prodotti: [],
      cmt_to_send: "",
      loading_commento: false,
      commento_ok: false,
      colori: [],
    };
  },
  created() {
    this.debouncecmt = _.debounce(this.send_commento, 1200);
  },
  watch: {
    nome_prodotto: function () {
      if (this.nome_prodotto.length < 3) {
        this.prodotto_sel_id = null;
        this.lista_prodotti = [];
        return;
      }
      let regex = new RegExp(this.nome_prodotto, "i");
      this.lista_prodotti = this.prodotti.filter((prod) =>
        regex.test(prod.nome)
      );
    },
    prodotto_sel: function () {
      this.fetchAllColors();
    },
  },
  computed: {
    prodotti() {
      return this.$store.getters.get_lista_prodotti_raw;
    },
    prodotto_sel() {
      return this.$store.getters.get_prodotto_by_id(this.prodotto_sel_id);
    },
    specie() {
      if (this.prodotto_sel) {
        return this.$store.getters.get_specie_by_id(this.prodotto_sel.specie);
      } else {
        return null;
      }
    },
    commento: {
      get() {
        let articolo_in_order = this.ordine.articoli.find(
          (art) => art.art == this.prodotto_sel_id
        );

        return articolo_in_order ? articolo_in_order.commento : "";
      },
      set(cmt) {
        this.cmt_to_send = cmt;
        this.debouncecmt();
      },
    },
    gruppo_serie() {
      const result = this.colori
        .filter(
          (colore) =>
            this.prodotto_sel.series.includes(colore.id_series[0]) ||
            (this.prodotto_sel.series.includes("000000") &&
              colore.id_series.length == 0)
        )
        .reduce((acc, obj) => {
          // Se l'array id_series è vuoto, aggiungi il prodotto sotto null
          if (obj.id_series.length === 0) {
            if (!acc[null]) {
              acc[null] = [];
            }
            acc[null].push(obj);
          } else {
            // Altrimenti, iteriamo su id_series e aggiungiamo il prodotto ai rispettivi id_series
            obj.id_series.forEach((id_series) => {
              if (!acc[id_series]) {
                acc[id_series] = [];
              }
              acc[id_series].push(obj);
            });
          }
          return acc;
        }, {});

      const finalArray = Object.entries(result).map(([key, value]) => ({
        id_series: key !== "null" ? key : null, // Converti 'null' in vero null
        colori: value,
      }));
      finalArray.sort((a, b) => {
        if (a.id_series === null) return -1;
        if (b.id_series === null) return 1;
        return 0; // Lascia invariato l'ordine per gli altri elementi
      });
      return finalArray;
    },
  },
  methods: {
    async fetchAllColors() {
      this.colori = [];
      this.colori = await this.$store.dispatch(
        "fetch_colori_by_id",
        this.specie.colori
      );
    },
    avatar_img(id) {
      return process.env.VUE_APP_API_ROOT + "/avatar_img/" + id;
    },
    send_commento() {
      this.loading_commento = true;
      this.$store
        .dispatch("modifica_commento", {
          ordine: this.ordine._id.$oid,
          id_prodotto: this.prodotto_sel_id,
          commento: this.cmt_to_send,
        })
        .then(() => {
          this.loading_commento = false;
          this.commento_ok = true;
          setTimeout(() => {
            this.commento_ok = false;
          }, 1500);
        });
    },
    get_serie(id_serie) {
      return this.specie.series.find((serie) => serie.id == id_serie);
    },
  },
};
